'use client';

// Third Party
import * as React from 'react';

// UI
import { ExpandableText } from '@components/expandable-text';

type Props = { cancellationPolicy: string };

export const CancellationPolicy: React.FC<Props> = ({ cancellationPolicy }) => {
  return (
    <ExpandableText
      text={cancellationPolicy}
      maxLines={9}
      data-testid="@cancellation/policy"
      typographyVariant="body2"
      typographyVariantM="body1"
      className="!font-light"
    />
  );
};
